import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Helmet} from "react-helmet";
import Navigation from './navigation';
import Footer from './footer';
import HeroPricing from './assets/hero-pricing.svg';
import MobileHeroPricing from './assets/hero-pricing-mobile.svg';
import Matt from './assets/matt-aidem.png';
import Aaron from './assets/aaron.png';
import Business from './assets/undraw_business_deal.svg';
import Businessman from './assets/undraw_businessman.svg';
import Tourists from './assets/undraw_group_selfie.svg';
import Daniel from './assets/daniel.png';
import Dike from './assets/dike.png';
import Frances from './assets/frances.png';
import Raman from './assets/raman.png';
import Scribbleplus from './assets/scribble-plus.svg';

class Pricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Scribble – An on demand blog-writing subscription for startups 📝</title>
          <meta name="description" content="Scribble is an on demand blog-writing subscription for startups starting at $499/mo. Scribble is the easiest way to put your blog on autopilot. ✈️" />

          <meta itemprop="name" content="Scribble – An on demand blog-writing subscription for startups 📝" />
          <meta itemprop="description" content="Scribble is an on demand blog-writing subscription for startups starting at $499/mo. Scribble is the easiest way to put your blog on autopilot. ✈️" />
          <meta itemprop="image" content="http://i.imgur.com/dMNMVHO.png" />

          <meta property="og:url" content="https://www.hiscribble.com" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Scribble – An on demand blog-writing subscription for startups 📝" />
          <meta property="og:description" content="Scribble is an on demand blog-writing subscription for startups starting at $499/mo. Scribble is the easiest way to put your blog on autopilot. ✈️" />
          <meta property="og:image" content="http://i.imgur.com/dMNMVHO.png" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Scribble – An on demand blog-writing subscription for startups 📝" />
          <meta name="twitter:description" content="Scribble is an on demand blog-writing subscription for startups starting at $499/mo. Scribble is the easiest way to put your blog on autopilot. ✈️" />
          <meta name="twitter:image" content="http://i.imgur.com/dMNMVHO.png" />
        </Helmet>
        <Navigation />
        { this.state.width > 900 ? <img
          src={ HeroPricing }
          className="is-overlay"
        /> : <img
          src={ MobileHeroPricing }
          className="is-overlay"
        />}
        <section className="section is-centered has-text-centered" style={{ minHeight: "35em", paddingTop: "0em" }}>
          <div className="container clear-pricing-section-card">
            <div className="pricing-head has-text-centered is-centered">
              <h1 className="title has-text-centered is-centered has-text-white" id="pricing">Put your blog on autopilot ✈️</h1>
              <p className="subtitle has-text-centered is-centered has-text-white pricing-sub">Scribble plans help you write & grow your blog at the same time. Upgrade and cancel anytime; no contracts.</p>
            </div>
            <div className="columns is-centered">
              <div className="column">
                <div className="card pricing-card">
                  <header className="pricing-card-header">
                    <div className="card-header-title is-centered">
                      Scribble 📝
                    </div>
                    <div className="title has-text-centered">
                      $499
                    </div>
                    <div className="subtitle has-text-centered is-size-6 is-transparent">
                      monthly
                    </div>
                  </header>
                  <div className="card-content has-text-centered">
                    <div className="content title is-5">
                      An on demand team of American writers at your whim
                    </div>
                    <div className="content title is-6 has-text-weight-normal">
                      📝 24/7 on demand access to our team of elite writers
                    </div>
                    <div className="content title is-6 has-text-weight-normal">
                      🇺🇸 Native English-speaking writers based in NYC & DC
                    </div>
                    <div className="content title is-6 has-text-weight-normal">
                      ⚡️ Unlimited requests & edits, no post limits
                    </div>
                    <div className="buttons is-centered">
                      <a className="button is-stripe-pricing" href="https://scribble.memberful.com/checkout?plan=32762">Subscribe for $499/mo</a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="column">
                <div className="card pricing-card-emphasis is-middle-pricing" style={{marginTop:'-1.5em'}}>
                  <header className="pricing-card-header-emphasis">
                    <div className="card-header-title is-centered has-blue-emphasis">
                      Scribble + Exclamation Bundle
                    </div>
                    <div className="title has-text-centered">
                      $699
                    </div>
                    <div className="subtitle has-text-centered is-size-6 is-transparent">
                      monthly
                    </div>
                  </header>
                  <div className="card-content has-text-centered">
                    <div className="content title is-5">
                      Writing your blog and promoting it put on autopilot
                    </div>
                    <div className="content title is-6 has-text-weight-normal">
                      📝 Everything in our Scribble blog writing package
                    </div>
                    <div className="content title is-6 has-text-weight-normal">
                      🚀 Everything in our Exclamation blog promotion package
                    </div>
                    <div className="content title is-6 has-text-weight-normal">
                      ❤️ Bundle discount & priority support
                    </div>
                    <div className="buttons is-centered">
                      <a className="button is-stripe-pricing" href="https://scribble.memberful.com/checkout?plan=32962">Subscribe for $699/mo</a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="column">
                <div className="card pricing-card">
                  <header className="pricing-card-header">
                    <div className="card-header-title is-centered">
                      Exclamation 🚀
                    </div>
                    <div className="title has-text-centered">
                      $249
                    </div>
                    <div className="subtitle has-text-centered is-size-6 is-transparent">
                      monthly
                    </div>
                  </header>
                  <div className="card-content has-text-centered">
                    <div className="content title is-5">
                      Seamlessly promote your new blog posts on reddit in seconds
                    </div>
                    <div className="content title is-6 has-text-weight-normal">
                      🚀 Promote up to 5 blog posts (written by Scribble or not) every month
                    </div>
                    <div className="content title is-6 has-text-weight-normal">
                      💌 Each blog post is shared on 10 targeted subreddits
                    </div>
                    <div className="content title is-6 has-text-weight-normal">
                      📊 A report of where your post was submitted
                    </div>
                    <div className="buttons is-centered">
                      <a className="button is-stripe-pricing" href="https://scribble.memberful.com/checkout?plan=32961">Subscribe for $249/mo</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="pricing-head has-text-centered is-centered">
              <p className="subtitle has-text-centered is-centered pricing-below-text is-size-6">All payments are processed securely through Stripe.</p>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container">
            <div className="columns has-text-centered is-centered">
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2 has-padding-bottom">
                  ✈️
                </div>
                <div className="title is-size-4 para-title">
                  Automate your blog so you can focus on your product & users
                </div>
              </div>
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  🤑
                </div>
                <div className="title is-size-4 para-title">
                  Improve your SEO, get more traffic, and attract new customers
                </div>
              </div>
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  ⚡️
                </div>
                <div className="title is-size-4 para-title">
                  Easily build your brand and reputation without the time commitment
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container clear-section-card">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered">Writing and promoting your blog put on autopilot ✈️</h2>
              <p className="subtitle has-text-centered is-centered pricing-sub">Scribble and Exclamation together is the easiest way to write and grow your blog.</p>
            </div>

                <img
                  src={ Scribbleplus }
                />

          </div>
        </section>

        <section className="section" id="FAQ">
          <div className="container clear-section-card-writing-samples">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered">FAQ</h2>
              <p className="subtitle has-text-centered is-centered pricing-sub">If our FAQ doesn't answer your questions, please reach out to us in our live chat in the bottom right.</p>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  How long does it take to process a writing request for Scribble?
                </div>
                <p className="is-size-6">After submitting a request, we’ll spend 3-5 business days researching and outlining your post, then send you a rough draft. We’ll work with you for as long as you like to refine that post until it’s ready for you to publish.</p>
              </div>
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  For Scribble, do you offer refunds?
                </div>
                <p className="is-size-6">You can cancel your subscription anytime. We have a 100% money-back guarantee until we’ve started processing a writing request that month.</p>
              </div>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  What is a writing request?
                </div>
                <p className="is-size-6">A writing request is one prompt submission––you'll get a special form after you sign up that walks you through everything.</p>
              </div>
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  For Scribble, can you add photos to the posts?
                </div>
                <p className="is-size-6">Yes.</p>
              </div>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  Do you have any writing samples?
                </div>
                <p className="is-size-6">Yes, see above.</p>
              </div>
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  For Scribble, do you write in any language other than English?
                </div>
                <p className="is-size-6">Not yet.</p>
              </div>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  With Exclamation, do you only promote blog posts that you’ve written through Scribble?
                </div>
                <p className="is-size-6">Nope! You can give us any blog post you'd like––old or new.</p>
              </div>
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  Is Exclamation compatible with Scribble on demand blog writing?
                </div>
                <p className="is-size-6">Yes! We've designed Exclamation to be a perfect fit. With both of these products you can automate both the writing and growing of your blog.</p>
              </div>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  How many Exclamation promotions can I run every month?
                </div>
                <p className="is-size-6">Up to 5!</p>
              </div>
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  Does Exclamation offer refunds?
                </div>
                <p className="is-size-6">Until we've started processing one of your promotions.</p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}

export default Pricing;



// WEBPACK FOOTER //
// ./src/pricing.js